import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import env from 'configs/env';
import useGetFile from 'middleware/hcp/files/useGetFile';
import { Recording } from 'types/hcp/recording.type';
import { getError } from 'utils/hcp/report/report.helper';
import { displayDateTimeWithOffset } from 'utils/helpers';

const NightError = ({
  recording,
  night,
  file,
  code,
}: {
  recording: Recording;
  night: string;
  file: string;
  code: string;
}) => {
  const { t } = useTranslation();
  const { file: fileUrl, fileLoading } = useGetFile(file);

  return (
    <Row className="main-row" gutter={[16, 16]}>
      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 14 }} xl={{ span: 16 }}>
        <StyledCard
          id="night-failed"
          title={t('nightly.failed', { night })}
          extra={
            <a href={fileUrl} target="_blank" rel="noreferrer">
              <Button
                id="download-report"
                size="middle"
                disabled={fileLoading}
                icon={<DownloadOutlined />}
                type="primary">
                {t('download-report')}
              </Button>
            </a>
          }>
          <div>
            <p id="support-page-text">
              {t('nightly.visit')}
              <a id="support-page" target="_blank" href={env.support} rel="noreferrer">
                {' '}
                {env.support}
              </a>
            </p>
            <br />
            <p>
              {t('error')}: {getError(code, recording?.settings?.tit_cutoff)}
            </p>
          </div>
        </StyledCard>
      </Col>
      <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} xl={{ span: 8 }}>
        <StyledCard id="info-label" title={t('nightly.info-label')}>
          <div>
            <Row gutter={[16, 16]}>
              <Col span={12}>{t('nightly.rec-start')}</Col>
              <Col span={12}>
                {displayDateTimeWithOffset(recording?.start, recording?.start_utc_offset)}
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col span={12}>{t('nightly.rec-end')}</Col>
              <Col span={12}>
                {displayDateTimeWithOffset(recording?.end, recording?.end_utc_offset)}
              </Col>
            </Row>
          </div>
        </StyledCard>
      </Col>
    </Row>
  );
};

export default NightError;
